<template>
  <div class="chat-conversations-list">
    <div class="chat-conversations-list-item">
      <div class="chat-conversations-list-item-avatar">
        <b-skeleton type="avatar" />
      </div>
      <div class="chat-conversations-list-item-info">
        <div class="chat-conversations-list-item-info-name">
          <b-skeleton />
        </div>
        <div class="chat-conversations-list-item-info-message">
          <b-skeleton />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessagesLoading'
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/ConversationsLoading.vue